module.exports = __webpack_public_path__ + "img/water.a03fe667.svg";